// extracted by mini-css-extract-plugin
export var chip = "_mm-0";
export var icon = "_mm-1";
export var remove = "_mm-2";
export var removeIcon = "_mm-3";